<template>
  <div class="h-spacer" :class="`h-spacer--${size}`"></div>
</template>
<script>
export default {
  props: {
    size: { type: String, required: true }, // xs, s, m, l
  },
};
</script>

<style lang="stylus" scoped>
.h-spacer--xs {
  height: 15px;
}
.h-spacer--s {
  height: 30px;
}
.h-spacer--m {
  height: 50px;
}
.h-spacer--m {
  height: 90px;
}
</style>
